import classNames from "classnames";
import styles from './external-ad.module.scss';
import useAdUnit from "../../../../infrastructure/hooks/ads/useAdUnit";
import {AdAdapexManager} from "../../../managers/ads/ad.adapex.manager";
import {ADS_PLATFORM_TYPE} from "../../../consts";
import {GoogleAdManager} from "../../../managers/ads/ad.google.manager";

export const ExternalAdContentUnit = ({controller, config}) => {
  const adManagerType = controller.state.appState.adsPlatformType === ADS_PLATFORM_TYPE.adapex ? AdAdapexManager :
    (controller.state.appState.adsPlatformType === ADS_PLATFORM_TYPE.google ? GoogleAdManager : null);

  const adManager = controller.props.ioc.getInstance(adManagerType);
  useAdUnit(adManager, config);

  const {adUnit, width, height} = config;

  const baseProps = {
    id: config.slotId,
    className: classNames(styles.ad),
    style: {minWidth: width, minHeight: height}
  };

  const adapexProps = {
    ...baseProps,
    'data-aaad': "true",
    'data-aa-adunit': adUnit,
    'data-aa-lazy-loaded': true,
    'data-aa-targeting': '{"has_hb": "on"}'
  };

  const googleProps = {
    ...baseProps
  }

  const unitProps = controller.state.appState.adsPlatformType === ADS_PLATFORM_TYPE.google ? googleProps : adapexProps;

  return <div {...unitProps}/>
};